import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { dateAsString } from '../../shared/date.helper';
import { FlagGroup, Inspection } from '../../shared/interfaces';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FlagService } from '../../flag/flag.service';

@Component({
  selector: 'app-extension-granted-deadlines',
  templateUrl: './extension-granted-deadlines.component.html',
  styleUrls: ['./extension-granted-deadlines.component.scss'],
})
export class ExtensionGrantedDeadlinesComponent implements OnInit {
  @ViewChild('setDatesModal', { static: true }) public setDatesModal: ModalDirective;
  @Input() selectedFlags: any;
  confirmCallback: () => void;
  cancelCallback: () => void;
  inspection: Inspection;
  loading = false;
  addDateForm: UntypedFormGroup;

  dateConfig = { dateInputFormat: 'MM-DD-YYYY', customTodayClass: 'date-today' };
  saving = false;

  constructor(
    private fb: UntypedFormBuilder,
    private flagService: FlagService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.addDateForm = this.fb.group({
      violationActionRequiredDeadline: ['', [Validators.required, this.dateAfterTodayValidator]],
      reason: ['', Validators.required],
    });

    this.setDatesModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  show(options: { confirmed?: () => void; canceled?: () => void; inspection: Inspection }) {
    this.loading = true;
    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.inspection = options.inspection;
    this.addDateForm.get('violationActionRequiredDeadline').setValue(null);
    this.addDateForm.reset();

    if (this.inspection.dueDate) {
    }
    this.cdr.detectChanges();
    this.setDatesModal.show();
    this.loading = false;
  }

  async save() {
    if (this.saving) return;
    this.loading = true;
    if (this.addDateForm.valid) {
      this.saving = true;
      const flagIds = this.selectedFlags.map(flag => flag.id);
      this.flagService.setFlagsDeadline({ flagIds, ...this.addDateForm.value }).then(() => {
        this.addDateForm.reset();
        this.setDatesModal.hide();
        this.saving = false;
        this.loading = false;
        return this.confirmCallback && this.confirmCallback();
      });
      this.setDatesModal.hide();
      this.saving = false;
    }
  }

  cancel() {
    this.setDatesModal.hide();
    return !!this.cancelCallback && this.cancelCallback();
  }

  setDeadline(to, field) {
    switch (to) {
      case '+30d':
        const d30 = new Date();
        d30.setDate(d30.getDate() + 30);
        this.addDateForm.get(field).setValue(dateAsString(d30));
        break;

      case '+60d':
        const d60 = new Date();
        d60.setDate(d60.getDate() + 60);
        this.addDateForm.get(field).setValue(dateAsString(d60));
        break;

      case '+90d':
        const d90 = new Date();
        d90.setDate(d90.getDate() + 90);
        this.addDateForm.get(field).setValue(dateAsString(d90));
        break;
    }
  }

  dateAfterTodayValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const selectedDate = new Date(control.value);
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
      return { dateInvalid: true };
    }

    return null;
  }
}
